var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"unsupported-card"},[_c('i',{staticClass:"fal fa-puzzle-piece"}),_c('div',{staticClass:"unsupported-card-body"},[_c('span',{staticClass:"unsupported-card-title"},[_vm._v(_vm._s(_vm.meta.label || _vm.meta.id))]),_c('span',{staticClass:"unsupported-card-desc"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }